/**
 * @generated SignedSource<<4f27a307d5e7ec8c7338d5d508a0caf1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AcceptPrivacyPolicyInput = {
  acceptPrivacyPolicy: boolean;
  acceptedPrivacyPolicyId: string;
};
export type Profile_acceptPrivacyPolicy_Mutation$variables = {
  input: AcceptPrivacyPolicyInput;
};
export type Profile_acceptPrivacyPolicy_Mutation$data = {
  readonly acceptPrivacyPolicy: {
    readonly user: {
      readonly id: string;
    };
  } | null;
};
export type Profile_acceptPrivacyPolicy_Mutation = {
  response: Profile_acceptPrivacyPolicy_Mutation$data;
  variables: Profile_acceptPrivacyPolicy_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AcceptPrivacyPolicyPayload",
    "kind": "LinkedField",
    "name": "acceptPrivacyPolicy",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Profile_acceptPrivacyPolicy_Mutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Profile_acceptPrivacyPolicy_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e578865d3df0bb93419f25be2c7e31a0",
    "id": null,
    "metadata": {},
    "name": "Profile_acceptPrivacyPolicy_Mutation",
    "operationKind": "mutation",
    "text": "mutation Profile_acceptPrivacyPolicy_Mutation(\n  $input: AcceptPrivacyPolicyInput!\n) {\n  acceptPrivacyPolicy(input: $input) {\n    user {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "da7376bca1009ebf3d875379b74cb771";

export default node;
